import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const FinlandFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14697'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14697)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.953125 8.39998H5.71354V14.9333H8.57068V8.39998H20.9516V5.59998H8.57068V-0.93335H5.71354V5.59998H-0.953125V8.39998Z'
					fill='#0848A6'
				/>
			</g>
		</svg>
	);
};

export default FinlandFlagIcon;
